import { render, staticRenderFns } from "./faultInfo.vue?vue&type=template&id=c54530be"
import script from "./faultInfo.vue?vue&type=script&lang=js"
export * from "./faultInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports